import avatarView from './avatarComponent.html';
import './avatarComponent.css';
import { ensure } from 'components/sharpr/ensure/ensure.js';

class avatarComponentCtrl {
	$onInit() {
		// Default src and useInitials, which may be updated depending on the "user" and "size" attributes passed in.
		this.useInitials = true;
		this.src = ''; // NOTE: When the "src" value is empty, the initials will be displayed rather than any avatar.
		this.initialsStyle = {};

		// Since "user" and "size" are both required, validate them first before attempting any other initializations.
		const targetUser = this.user && typeof this.user === 'object' ? this.user : null;
		const avatarSize = this.size && !isNaN(parseInt(this.size)) ? parseInt(this.size) : 0;

		if (targetUser && avatarSize) {
			this.user = targetUser;
			this.size = avatarSize;
			this.initialsStyle.width = `${avatarSize}px`;
			this.initialsStyle.height = `${avatarSize}px`;
			this.initialsStyle.fontSize = `${avatarSize * 0.4375}px`;

			// Decide whether to show the gravatar, avatar or just stick with the initials.
			const avatar = ensure.string(targetUser.avatar, '');

			// NOTE: Also ignore if "avatar" contains "avatar-placeholder", for which we just want the defaults.
			if (avatar && avatar.match(/avatar-placeholder/) === null) {
				this.useInitials = false;

				const doubleSize = 2 * avatarSize;

				if (avatar.match(/^https:\/\/www\.gravatar\.com\//)) {
					this.src = avatar + '&s=' + doubleSize;
				} else if (avatar.match(/\/assets\/img\//)) {
					this.src = avatar;
				} else {
					this.src = avatar + '.exact-' + doubleSize + 'x' + doubleSize + '.scaleup-off.jpg';
				}
			}
		} else {
			this.user = null;
			this.size = 0;
		}
	}
}

export default function avatarComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {
			user: '=',
			size: '<',
			class: '@?',
		},
		controllerAs: 'vm',
		controller: avatarComponentCtrl,
		template: avatarView,
	};
}
